<span class="search-trigger" role="button" tabindex="0" (click)="openSearch()" (keydown.enter)="openSearch()" (keydown.space)="openSearch()">
    <fa-icon [icon]="faSearch" aria-hidden="true" />
    <span class="search-text">{{ 'global.search.title' | artemisTranslate }}</span>
    <kbd class="keyboard-hint">{{ actionKeyLabel() }}{{ isMac() ? 'K' : '+K' }}</kbd>
</span>
